import { get, IHttpRequestConfig } from "@/browser";
import { applyHeaders, extractDataFromResponse } from "@/core/api";
import { compose, IURLSearchParams } from "@/core/url";
import {
  IPageableWorkOrderLifecycle,
  IPartialPageableWorkOrderLifecycle,
  IWorkOrder,
  pageableWorkOrderLifecycleType,
  workOrderType,
} from "@/data/work-orders/types";

const API = {
  get: "/api/work-orders/{workOrderId}",
  lifecycle: "/api/work-orders/{workOrderId}/life-cycle",
};

export interface IFetchWorkOrderParams {
  workOrderId: number;
  companyId?: number;
}

export const fetchWorkOrder = (params: IFetchWorkOrderParams, options: IHttpRequestConfig) => {
  const { companyId, ...pathParams } = params;
  const url = compose(API.get, pathParams);

  return get<IWorkOrder>(url, applyHeaders({ companyId }, options)).then(extractDataFromResponse).then(workOrderType);
};

export interface IFetchWorkOrderLifecycleListParams extends IURLSearchParams {
  workOrderId: number;
  companyId?: number;
}

export const fetchWorkOrderLifecycleList = (
  params: IFetchWorkOrderLifecycleListParams,
  options: IHttpRequestConfig = {},
): Promise<IPageableWorkOrderLifecycle> => {
  const { workOrderId, companyId, ...searchParams } = params;
  const url = compose(API.lifecycle, { workOrderId }, searchParams);

  return get<IPartialPageableWorkOrderLifecycle>(url, applyHeaders({ companyId }, options))
    .then(extractDataFromResponse)
    .then(pageableWorkOrderLifecycleType);
};
